export default __webpack_public_path__ + "static/media/G0860.Breech_allfours_handing2.1692873900000.e80ebd35.jpg";